export const ATOMIZER_ERROR = 'atomizer::rebuilding'
export const ATOMIZER_ERROR_MESSAGE = 'Existe uma operação em execução para esse mapa de vagas, por favor aguarde até ela finalizar, tente novamente mais tarde.'
